import { Component, ReactNode } from "react";

interface Props { children: ReactNode }
interface State { error: Error | null }

/**
 * Last-resort error boundary so a runtime error in any descendant doesn't
 * unmount the whole React root and leave the user staring at a blank page.
 * Captures to Sentry if it's wired, falls back to a minimal message UI.
 */
class RootErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error("[RootErrorBoundary]", error);
    const sentry = (window as unknown as { Sentry?: { captureException: (e: unknown) => void } }).Sentry;
    sentry?.captureException(error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      /* Culorile vin din tokenii Graphite, nu din utilitarele Tailwind: acelea
         se sprijină pe --primary, care e cyanul temei dinainte. Ecranul care
         apare exact când ceva a mers prost era singurul loc din site care mai
         randa brandul vechi. */
      <div className="errscreen">
        <div>
          <div className="errhead">Something broke.</div>
          <p>
            Sorry — the page hit a runtime error. Try refreshing. If it keeps happening,
            email <a href="mailto:services@coresmith.dev">services@coresmith.dev</a>.
          </p>
          <button type="button" className="act act-a" onClick={() => location.reload()}>Reload</button>
        </div>
      </div>
    );
  }
}

export default RootErrorBoundary;
